import { render } from "./integrations-list.vue?vue&type=template&id=1fab7d86&scoped=true"
import script from "./integrations-list.vue?vue&type=script&lang=js"
export * from "./integrations-list.vue?vue&type=script&lang=js"

import "./integrations-list.vue?vue&type=style&index=0&id=1fab7d86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fab7d86"]])

export default __exports__